import gsap from "gsap";
import { useState, useRef, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from 'react-router-dom';
import logo2 from '../images/logo2.png'
import "./footer.css";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

export default function Footer() {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };

    const goToOurThemes = () => {
        navigate('/ourThemes');
    };

    const goToOurGuages = () => {
        navigate('/ourGuages');
    };

    const goToOurHardwareAndDisplays = () => {
        navigate('/ourHardwareAndDisplays');
    };

    const goToDesignYourOwnGuages = () => {
        navigate('/designYourOwnGuages');
    };

    const goToGuagesForTunedCars = () => {
        navigate('/guagesForTunedCars');
    };

    const goToEvo = () => {
        navigate('/evo');
    };

    const goToOurWork = () => {
        navigate('/ourWork');
    };

    const goToOtherProducts = () => {
        navigate('/otherProducts');
    };

    const goToClassicGuages = () => {
        navigate('/classicGuages');
    };

    const goToAboutUs = () => {
        navigate('/aboutUs');
    };

    const goToMeetOurFamily = () => {
        navigate('/meetOurFamily');
    };

    const goToOurValues = () => {
        navigate('/ourValues');
    };



    return (
        <footer className="footer">
            {/* <div className="footer-top">
                <div className="footer-logo" onClick={goToHome}>
                    <h1>LOGO</h1>
                    <p>SOLOGAN COMPANY</p>
                </div>
                <div className="footer-links">
                    <div>
                        <p onClick={goToOurThemes}>OUR THEMES</p>
                        <p onClick={goToOurGuages}>OUR GUAGES</p>
                        <p onClick={goToOurHardwareAndDisplays}>OUR HARDWARE & DISPLAYS</p>
                    </div>
                    <div>
                        <p onClick={goToDesignYourOwnGuages}>DESIGN YOUR OWN GUAGES</p>
                        <p onClick={goToGuagesForTunedCars}>GUAGES FOR TUNED CARS</p>
                        <p onClick={goToEvo}>EVO* SPECIALIZED THEMES AND GUAGES</p>
                    </div>
                    <div>
                        <p onClick={goToOurWork}>CHECK OUT OUR WORK</p>
                        <p onClick={goToOtherProducts}>CHECK OTHER PRODUCTS</p>
                        <p onClick={goToClassicGuages}>CLASSIC GUAGES</p>
                    </div>
                    <div>
                        <p onClick={goToAboutUs}>ABOUT US</p>
                        <p onClick={goToMeetOurFamily}>MEET OUR [name] FAMILY</p>
                        <p onClick={goToOurValues}>OUR VALUES</p>
                    </div>
                </div>
            </div> */}
            <div className="footer-bottom">
                <div className="short-logo" onClick={goToHome}>
                    {/* <div className='bandara-footer'>B</div>
                    <div className='motoren-footer'>M</div> */}
                    <img src={logo2} className="logo-footer" />
                </div>
                <div className="bandara-motoren">Bandara Motoren</div>
                <div className="after-market">an aftermarket accessory manufacturer</div>
                <div className="social-media">
                    <div className="social-icon"><i className="fa-brands fa-tiktok"></i></div>
                    <div className="social-icon"><i className="fab fa-facebook-f"></i></div>
                    <div className="social-icon"><i className="fab fa-twitter"></i></div>
                    {/* <div className="social-icon"><i className="fab fa-google-plus-g"></i></div> */}
                    {/* <div className="social-icon"><i className="fas fa-ellipsis-h"></i></div> */}
                </div>
                <p>&copy; Copyright. All rights reserved.</p>
                <br />
                <p className="dedicated">Dedicated to </p>
                <p>Jeremy Clarkson</p>
                <p>Richard Hammond</p>
                <p>James May</p>
            </div>
        </footer>
    );
}